import api from "../axiosIntercepture";
import { requireId, storerFetchList, storerRequest } from "../storer/storerRequest";


export const getCustomerID = async () => {
    try {
        const response = await api.get('/ordermanagement/getCustId');
        return response?.data;
    }
    catch (err) {
        throw err?.response;
    }
}


export const saveCustomerAPI = async (data) => {
    try {
        const response = await api.post('/ordermanagement/saveCustomer', data);
        return response?.data;
    }
    catch (err) {
        throw err?.response;
    }
}

export const getCustomerListAPI = async (page, pageSize) => {
    try {
        const response = await api.post(`/ordermanagement/getCustomerList?page=${page+1}&pageSize=${pageSize}`);
        return response?.data.data;
    }
    catch (err) {
        throw err?.response;
    }
}

const resolveTenantId = (tenantId) => {
    if (tenantId == null || tenantId === "") return "";
    if (typeof tenantId === "object" && tenantId._id != null) return String(tenantId._id);
    return String(tenantId);
};

/**
 * GET `/tenant/organization/customers/by-tenant?tenantId=&page=&pageSize=`
 * @param {string|{ _id?: string }} tenantId — raw tenant id or `{ _id }` from `userDetail.tenantId`
 * @param {{ page?: number, pageSize?: number }} [options] — defaults page 1, pageSize 500 (dropdown-friendly)
 * @returns {Promise<Array>} customer rows for that page
 */
export const getCustomerListByTenantAPI = async (tenantId, options = {}) => {
    try {
        const id = resolveTenantId(tenantId);
        if (!id) return [];
        const page = Math.max(1, Number(options.page) || 1);
        const pageSize = Math.min(2000, Math.max(1, Number(options.pageSize) || 500));
        const params = new URLSearchParams({
            tenantId: id,
            page: String(page),
            pageSize: String(pageSize),
        });
        const response = await api.get(`/tenant/organization/customers/by-tenant?${params.toString()}`);
        const root = response?.data;
        if (!root) return [];
        if (Array.isArray(root)) return root;
        // { data: [...], pagination } OR { data: { data: [...], pagination } }
        const first = root.data;
        if (Array.isArray(first)) return first;
        if (first && typeof first === "object") {
            if (Array.isArray(first.data)) return first.data;
            const nested =
                first.records ??
                first.items ??
                first.customers ??
                first.list ??
                first.results ??
                first.content;
            if (Array.isArray(nested)) return nested;
        }
        const list =
            root.records ??
            root.items ??
            root.customers ??
            root.list ??
            root.results ??
            root.content ??
            [];
        return Array.isArray(list) ? list : [];
    } catch (err) {
        const msg =
            err?.response?.data?.message ||
            err?.response?.data?.error ||
            err?.message ||
            "Failed to load customers";
        throw typeof msg === "string" ? msg : err?.response || err;
    }
};

export const updateCustomerAPI = async (data,id) => {
    try {
        const response = await api.post(`/ordermanagement/updateCustomer/${id}`, data);
        return response?.data;
    }
    catch (err) {
        throw err?.response;
    }
}

/* Customer Management — /api/customer-group and /api/customer-group/ship-to */

export const getallcustomer = (page, pageSize, filters) =>
    storerFetchList("customer-group/fetch-multi-dynamic", page, pageSize, filters);

export const searchCustomerById = (page, pageSize, filters) =>
    storerFetchList("customer-group/fetch-multi-details", page, pageSize, filters);

export const addCustomer = (userData) =>
    storerRequest("post", "customer-group/create", userData, "Failed to create customer");

export const onboardCustomer = (body) =>
    storerRequest("post", "customer-group/onboardPartner", body, "Failed to onboard customer");

export const updateCustomer = (userData, id) =>
    storerRequest(
        "put",
        `customer-group/update/${requireId(id, "Missing customer id")}`,
        userData,
        "Failed to update customer"
    );

export const disableCustomer = (body) =>
    storerRequest("post", "customer-group/disablePartner", body, "Failed to disable customer");

export const fetchShipTos = (page, pageSize, filters) =>
    storerFetchList("customer-group/ship-to/fetch-multi-dynamic", page, pageSize, filters);

export const addShipTo = (userData) =>
    storerRequest("post", "customer-group/ship-to/create", userData, "Failed to create ship to");

export const updateShipTo = (userData, id) =>
    storerRequest(
        "put",
        `customer-group/ship-to/update/${requireId(id, "Missing ship to id")}`,
        userData,
        "Failed to update ship to"
    );

export const deleteShipTo = (id) =>
    storerRequest(
        "delete",
        `customer-group/ship-to/delete/${requireId(id, "Missing ship to id")}`,
        undefined,
        "Failed to delete ship to"
    );

